import React from "react";
import { Space, Divider } from 'antd';
import { FacebookOutlined, InstagramOutlined } from '@ant-design/icons';
import { usePrefs } from "../utils/Prefs";
import CSS from "../utils/CSS";
import { getColor } from "../utils/ConvertCSS";
import { useTemplate } from "../utils/Template";
import conditional from "../utils/conditional";
import { BlueskyIcon, MastodonIcon, ThreadsIcon, TikTokIcon, TwitterIcon } from "../admin/Icons";
import Html from "../utils/Html";
import GovIcon from "../admin/Components/GovIcon";
import { trimTrailingChar } from "../utils/Utils";

export default function SiteFooter(props) {

    const [prefs,] = usePrefs();
    const [template,] = useTemplate();
    const { view = "desktop" } = props;
    const {
        data = {},
    } = prefs.footer_bar;

    const {
        background_colour = 0,
        text_colour = 0,
        link_colour = 0,
        link_hover_colour = 0,
        width = 1248,
        terms_condition_enabled = false,
        privacy_policy_enabled = false,
        contact_us_menu_id = "",
        font_size = 14
    } = data;

    // Destructure for store_info
    const { store_info = {} } = window.storesettings;
    const {
        name = "",
        phone = "",
        phone_2 = "",
        toll_free = "",
        fax = "",
        email = "",
        city = "",
        address = "",
        province = "",
        postal_code = "",
        country = "",
        twitter = "",
        facebook = "",
        instagram = "",
        tiktok = "",
        threads = "",
        bluesky = "",
        mastodon = "",
        url = "",
        footer_message = "",
    } = store_info;


    let _class = ``;

    _class += `

    .gov_color{
        fill : ${getColor(link_colour, template, "#fff")};
    }

    .bm_footer {
        background: ${getColor(background_colour, template, "#000")};
        color: ${getColor(text_colour, template, "#fff")};
        font-size : ${font_size}px;
    }`;

    _class += `
    .bm_footer a{
        color: ${getColor(link_colour, template, "#fff")};
    }`;

    _class += `
    .bm_footer a:hover{
        color: ${getColor(link_hover_colour, template, "#fff")};
    }`;

    const formatURL = (url) => {
        url = url.replace("https://", "");
        url = url.replace("http://", "");
        url = url.replace("www.", "");
        return url;
    }


    const drawPrivacyPolicy = () => {

        if (!privacy_policy_enabled) {
            return (<></>)
        }

        return (<div style={{ "textAlign": "center" }}>
            <a href="/">View our Privacy Policy</a>
        </div>
        )
    }

    const drawTerms = () => {
        // Set by Webstore Designer
        if (!window.sitesettings.is_v1) {
            if (terms_condition_enabled) {
                return (
                    <div style={{ "textAlign": "center" }}>
                        <a href="/">View our Terms and Conditions</a>
                    </div>
                )
            } else {
                return (<></>)
            }
        }

        // Set by Webstore Designer
        if (!store_info.has_privacy_policy_page) {
            return (<></>)
        }
        return (
            <div style={{ "textAlign": "center" }}>
                <a href="/">View our Privacy Policy</a>
            </div>
        )
    }

    // Draw footer message if set
    const drawFooterMessage = () => {
        if (!footer_message) {
            return (<></>);
        }
        return (
            <div style={{ "maxWidth": width + "px", "margin": "0 auto", "textAlign": "center", "padding": "0px 20px" }}>
                <Html className="bm-anchor" clear={false} html={footer_message} />
                <div className="shim" /><div className="shim" />
            </div>
        )
    }

    const drawPoweredBy = () => {
        return (
            <div className="poweredby" style={{ "textAlign": "center", "opacity": "0.6" }}>
                <a href="/">
                    <span style={{ "fontSize": "8px" }}><small><em>Powered by </em></small></span><span style={{ "fontSize": "12px" }}><strong>Bookmanager</strong></span>
                </a>
            </div>
        )
    }

    function findMenuById(menuArray, menuId) {
        for (const item of menuArray) {
            if (item.menu_id === menuId) {
                return item;
            }

            if (item.submenu) {
                const found = findMenuById(
                    Array.isArray(item.submenu) ? item.submenu : [item.submenu],
                    menuId
                );
                if (found) return found;
            }
        }
        return null;
    }

    const getContactPagePath = () => {



        if (window.storesettings.is_v1) {
            return window.storesettings.store_info.contact_us_url
        } else {

            // Search Nav
            let c = findMenuById(window.storesettings.site_navigation, contact_us_menu_id);
            if (c) { return c.path; }

            // Search Extra
            c = window.storesettings.extra_navigation.find(item => item.menu_id === contact_us_menu_id);
            if (c) {
                return c.path;
            }
            // Return Default
            return window.storesettings.store_info.contact_us_url;
        }
    }

    const contact_page_path = trimTrailingChar(window.sitesettings.url, "/") + getContactPagePath();

    const drawAddress = () => {
        return (
            <div className="site-footer-item">

                <conditional.true value={(!store_info.hide_footer_address)}>
                    <div><big><strong>Find us at</strong></big></div>
                    <div className="shim" /><div className="shim" />
                    <p>
                        {name}<br />
                        {address}<br />
                        {city}, {province}<br />
                        {country}&nbsp;
                        {postal_code}<br />
                        <a target="_blank" href={contact_page_path}><strong>Map & Hours</strong></a>
                    </p>
                    <div className="shim" /> <div className="shim" /> <div className="shim" />

                </conditional.true>
            </div>
        )
    }

    const drawContact = () => {
        return (
            <div className="site-footer-item">
                <div><big><strong>Contact us</strong></big></div>
                <div className="shim" /><div className="shim" />
                <p>
                    {(phone && <><a href={"tel:" + phone}>{phone}</a> <br /></>)}
                    {(phone_2 && <><a href={"tel:" + phone_2}>{phone_2}</a> <br /></>)}
                    {(toll_free && <>Toll Free : <a href={"tel:" + toll_free}>{toll_free}</a> <br /></>)}
                    {(email && <><a href={"mailto:" + email}>{email} </a> <br /></>)}
                    {(url && <><a href={url}>{formatURL(url)} </a><br /></>)}
                    {(fax && <>Fax : {fax} <br /></>)}
                </p>
                <div className="shim" /> <div className="shim" /> <div className="shim" />
            </div>
        )
    }

    // Draw gov logo if set - draw bilingual version if set
    const drawGovernment = () => {
        if (!window.storesettings.show_government_of_canada_logo) {
            return (<></>)
        }
        return (
            <div style={{ "textAlign": "center", "width": (window.storesettings.government_of_canada_bilingual) ? "350px" : "200px" }}>
                <GovIcon bilinual={window.storesettings.government_of_canada_bilingual} />
            </div>
        )
    }

    const drawSocial = () => {
        return (
            <div className="site-footer-item">
                <div><big><strong>Social</strong></big></div>
                <div className="shim" /><div className="shim" />
                <Space direction="vertical">
                    {(twitter && <div aria-label="Twitter" type="text"><a href="/"><TwitterIcon className="icon-btn" style={{ "fontSize": "27px" }} /></a></div>)}
                    {(instagram && <div aria-label="Instagram" type="text"><a href="/"><InstagramOutlined className="icon-btn" style={{ "fontSize": "27px" }} /></a></div>)}
                    {(facebook && <div aria-label="Facebook" type="text"><a href="/"><FacebookOutlined className="icon-btn" style={{ "fontSize": "27px" }} /></a></div>)}
                    {(tiktok && <div aria-label="Tiktok" type="text"><a href="/"><TikTokIcon className="icon-btn" style={{ "fontSize": "27px" }} /></a></div>)}
                    {(threads && <div aria-label="Threads" type="text"><a href="/"><ThreadsIcon className="icon-btn" style={{ "fontSize": "27px" }} /></a></div>)}
                    {(bluesky && <div aria-label="Bluesky" type="text"><a href="/"><BlueskyIcon className="icon-btn" style={{ "fontSize": "27px" }} /></a></div>)}
                    {(mastodon && <div aria-label="Tiktok" type="text"><a href="/"><MastodonIcon className="icon-btn" style={{ "fontSize": "27px" }} /></a></div>)}
                </Space>
                <div className="shim" /> <div className="shim" /> <div className="shim" />
            </div>
        )
    }

    const drawCurrency = () => {
        let _cur = (window.sitesettings.is_canadian) ? "CAD" : "USD";
        return (<div style={{ "textAlign": "center" }}>Prices in {_cur}</div>);
    }

    const draw = () => {
        return (
            <>
                <CSS html={_class} />
                <div className="bm_footer bm-render">
                    <div style={{ "maxWidth": width + "px", "margin": "0 auto", "padding": "0px 30px" }}>
                        <div style={{ "display": "flex", "flexDirection": (view === "phone") ? "column" : "row", "textAlign": (view === "phone") ? "center" : "left", "alignItems": (view === "phone") ? "center" : "flex-start", "justifyContent": "space-between", "paddingTop": "40px" }} >
                            <div>{drawAddress()}</div>
                            <div>{drawContact()}</div>
                            {((twitter || facebook || instagram || tiktok) && <div>{drawSocial()}</div>)}
                        </div>
                    </div>
                    {drawFooterMessage()}
                    <div style={{ "opacity": "0.2" }}><Divider style={{ "borderColor": getColor(text_colour, template, "#fff"), margin: "15px 0px" }} /></div>
                    <div style={{ "textAlign": "center" }}>
                        <Space style={{ "flexDirection": (view === "phone") ? "column" : "row" }} size={(view === "phone" || view === "tablet") ? 15 : 50} align="center">
                            {drawTerms()}
                            {drawPrivacyPolicy()}
                            {drawGovernment()}
                            {drawCurrency()}
                            {drawPoweredBy()}
                        </Space>
                    </div>
                    <div className="shim" /> <div className="shim" /> <div className="shim" /> <div className="shim" />
                </div>
            </>
        )
    }

    return draw();

}

